export default __webpack_public_path__ + "static/media/logo_parceiro_02.d989d594.svg";